"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInsectIdFromValueGroup = void 0;
const getInsectIdFromValueGroup = (valueGroup) => {
    const insectIdRaw = valueGroup.split('_').slice(-1)[0];
    if (!insectIdRaw)
        return null;
    const insectId = Number(insectIdRaw);
    return isNaN(insectId) ? null : insectId;
};
exports.getInsectIdFromValueGroup = getInsectIdFromValueGroup;
//# sourceMappingURL=getInsectIdFromValueGroup.js.map